// Traction Power Calculator: field metadata + client-side per-field validation, used for
// instant inline feedback as the user types. The actual force/power math and the
// authoritative (server-side) validation live in the main backend — see
// src/lib/toolsApi.js (tractionPowerToolApi) and backend/tools/traction_power_tool.py.

export const DEFAULT_INPUTS = {
  speedKmph: 80,
  gradePercent: 0,
  accelerationMs2: 0,

  vehicleMassKg: 1500,
  dragCoefficient: 0.30,
  frontalAreaM2: 2.20,
  rollingResistanceCoefficient: 0.012,

  drivetrainEfficiencyPercent: 90,
};

// min / max mirror FIELD_SPECS in backend/core/lookup/traction_power_specs.py.
export const FIELD_SPECS = [
  { key: 'speedKmph', label: 'Vehicle Speed', unit: 'km/h', group: 'motion', min: 0, max: 250, strictlyPositive: false },
  { key: 'gradePercent', label: 'Road Gradient', unit: '%', group: 'motion', min: -20, max: 20, strictlyPositive: false },
  { key: 'accelerationMs2', label: 'Acceleration', unit: 'm/s²', group: 'motion', min: -3, max: 3, strictlyPositive: false },

  { key: 'vehicleMassKg', label: 'Vehicle Mass', unit: 'kg', group: 'vehicle', min: 500, max: 4000, strictlyPositive: false },
  { key: 'dragCoefficient', label: 'Drag Coefficient', unit: 'Cd', group: 'vehicle', min: 0.15, max: 0.60, strictlyPositive: false },
  { key: 'frontalAreaM2', label: 'Frontal Area', unit: 'm²', group: 'vehicle', min: 1.5, max: 4.0, strictlyPositive: false },
  { key: 'rollingResistanceCoefficient', label: 'Rolling Resistance Coefficient', unit: 'Crr', group: 'vehicle', min: 0.005, max: 0.030, strictlyPositive: false },

  { key: 'drivetrainEfficiencyPercent', label: 'Drivetrain Efficiency', unit: '%', group: 'drivetrain', min: 60, max: 100, strictlyPositive: false },
];

export function validateField(spec, rawValue) {
  if (rawValue === '' || rawValue === null || rawValue === undefined) {
    return 'Required.';
  }
  const value = Number(rawValue);
  if (Number.isNaN(value)) {
    return 'Must be a number.';
  }
  if (spec.strictlyPositive && value <= 0) {
    return 'Must be greater than 0.';
  }
  if (spec.min !== null && value < spec.min) {
    return `Must be ≥ ${spec.min}.`;
  }
  if (spec.max !== null && value > spec.max) {
    return `Must be ≤ ${spec.max}.`;
  }
  return null;
}
